var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorelogicLogoMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2167_71884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.01858 9.26587L0.106934 4.69232L8.01858 0.118774L15.9911 4.69232L8.01858 9.26587Z",
    fill: "#E92300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.106934 4.69238L8.01858 9.26593L0.106934 13.9018V4.69238Z",
    fill: "#D9D9D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.106934 13.9018L8.01858 18.413V9.26587L0.106934 13.9018Z",
    fill: "#424243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01855 9.26587V18.413L15.9287 13.8394L8.01855 9.26587Z",
    fill: "#959595"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2167_71884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18.6667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorelogicLogoMark);
export default __webpack_public_path__ + "static/media/Corelogic-logo-mark.ad5488f421e6b140055a4ad8585dbe8b.svg";
export { ForwardRef as ReactComponent };